import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'timeFormat',
})
export class TimeFormatPipe implements PipeTransform {
    transform(value: number, includeTenths: boolean = false): string {
        if (value == null || isNaN(value)) return '00:00';

        const totalMilliseconds = value;
        const totalSeconds = Math.floor(totalMilliseconds / 1000);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;

        const minutesStr = minutes < 10 ? '0' + minutes : minutes.toString();
        const secondsStr = seconds < 10 ? '0' + seconds : seconds.toString();

        if (includeTenths) {
            const tenths = Math.floor((totalMilliseconds % 1000) / 100);
            return `${minutesStr}:${secondsStr}.${tenths}`;
        } else {
            return `${minutesStr}:${secondsStr}`;
        }
    }
}
